var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "flex justify-center my-8" },
      [
        _c("steps", {
          attrs: {
            "current-step": _vm.step,
            steps: [
              { name: "Billing" },
              { name: "Payment" },
              { name: "Complete" },
            ],
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8" }, [
      _c("div", { staticClass: "grid grid-cols-5 gap-10" }, [
        _c("div", { staticClass: "col-span-3" }, [
          _vm.step === 0
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitBillingForm.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "grid grid-cols-2 gap-6" },
                    [
                      _c("form-select", {
                        attrs: {
                          label: "Membership Plan",
                          options: _vm.plans,
                          "track-as-integer": true,
                          required: "",
                          error: _vm.getErrorFor("membership_plan"),
                        },
                        model: {
                          value: _vm.form.membership_plan,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "membership_plan", $$v)
                          },
                          expression: "form.membership_plan",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-select", {
                        attrs: {
                          label: "Payment Type",
                          options: [
                            { name: "Monthly", value: "monthly" },
                            { name: "Yearly", value: "yearly" },
                          ],
                          "track-by": "value",
                          required: "",
                          error: _vm.getErrorFor("payment_type"),
                        },
                        model: {
                          value: _vm.form.payment_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "payment_type", $$v)
                          },
                          expression: "form.payment_type",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-input", {
                        attrs: {
                          label: "First Name",
                          required: "",
                          error: _vm.getErrorFor("first_name"),
                        },
                        model: {
                          value: _vm.form.first_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "first_name", $$v)
                          },
                          expression: "form.first_name",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-input", {
                        attrs: {
                          label: "Last Name",
                          required: "",
                          error: _vm.getErrorFor("last_name"),
                        },
                        model: {
                          value: _vm.form.last_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "last_name", $$v)
                          },
                          expression: "form.last_name",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-input", {
                        attrs: {
                          type: "email",
                          label: "Email",
                          required: "",
                          error: _vm.getErrorFor("email"),
                        },
                        model: {
                          value: _vm.form.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-input", {
                        attrs: {
                          type: "number",
                          label: "Phone",
                          required: "",
                          error: _vm.getErrorFor("phone"),
                        },
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-input", {
                        attrs: {
                          label: "Address 1",
                          required: "",
                          error: _vm.getErrorFor("address_1"),
                        },
                        model: {
                          value: _vm.form.address_1,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "address_1", $$v)
                          },
                          expression: "form.address_1",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-input", {
                        attrs: {
                          label: "Address 2",
                          error: _vm.getErrorFor("address_2"),
                        },
                        model: {
                          value: _vm.form.address_2,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "address_2", $$v)
                          },
                          expression: "form.address_2",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-input", {
                        staticClass: "col-span-2",
                        attrs: {
                          label: "Town / City",
                          required: "",
                          error: _vm.getErrorFor("town"),
                        },
                        model: {
                          value: _vm.form.town,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "town", $$v)
                          },
                          expression: "form.town",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-input", {
                        attrs: {
                          label: "County",
                          required: "",
                          error: _vm.getErrorFor("county"),
                        },
                        model: {
                          value: _vm.form.county,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "county", $$v)
                          },
                          expression: "form.county",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-input", {
                        attrs: {
                          label: "Post Code",
                          required: "",
                          error: _vm.getErrorFor("post_code"),
                        },
                        model: {
                          value: _vm.form.post_code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "post_code", $$v)
                          },
                          expression: "form.post_code",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-select", {
                        staticClass: "col-span-2",
                        attrs: {
                          label: "Country",
                          options: _vm.countries,
                          "track-by": "value",
                          required: "",
                          error: _vm.getErrorFor("country"),
                        },
                        model: {
                          value: _vm.form.country,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "country", $$v)
                          },
                          expression: "form.country",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-textarea", {
                        staticClass: "col-span-2",
                        attrs: {
                          label: "Notes",
                          error: _vm.getErrorFor("notes"),
                        },
                        model: {
                          value: _vm.form.notes,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "notes", $$v)
                          },
                          expression: "form.notes",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex justify-end mt-6" },
                    [
                      _c("form-button", { attrs: { type: "submit" } }, [
                        _vm._v(
                          "\n                            Continue\n                        "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              )
            : _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitPaymentForm.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("payment-options", {
                    model: {
                      value: _vm.form.payment_method,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "payment_method", $$v)
                      },
                      expression: "form.payment_method",
                    },
                  }),
                  _vm._v(" "),
                  _c("h2", [_vm._v("Vouchers")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                        If you have a voucher code, please enter it below to apply it to your booking.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("form-voucher", {
                    on: {
                      "voucher-applied": function ($event) {
                        _vm.credit = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("h2", { staticClass: "mt-10" }, [
                    _vm._v("Contact Preferences & Terms"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "font-semibold text-gray-600 mt-4" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center" },
                        [
                          _c("form-toggle", {
                            model: {
                              value: _vm.form.marketing,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "marketing", $$v)
                              },
                              expression: "form.marketing",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-2" }, [
                            _vm._v(
                              "\n                                Contact me with latest news and offers\n                            "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex items-center mt-2" },
                        [
                          _c("form-toggle", {
                            model: {
                              value: _vm.form.adult,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "adult", $$v)
                              },
                              expression: "form.adult",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-2" }, [
                            _vm._v(
                              "\n                                I confirm that I am at least 18 years of age\n                            "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasError("adult")
                        ? _c(
                            "div",
                            { staticClass: "ml-12 mt-1 text-xs text-red-600" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.getErrorFor("adult")) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex items-center mt-2" },
                        [
                          _c("form-toggle", {
                            model: {
                              value: _vm.form.terms,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "terms", $$v)
                              },
                              expression: "form.terms",
                            },
                          }),
                          _vm._v(" "),
                          _vm._m(0),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasError("terms")
                        ? _c(
                            "div",
                            { staticClass: "ml-12 mt-1 text-xs text-red-600" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.getErrorFor("terms")) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex justify-end mt-6" },
                    [
                      _c("form-button", { attrs: { type: "submit" } }, [
                        _vm._v(
                          "\n                            Continue\n                        "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-span-2" },
          [
            _c("membership-basket", {
              attrs: {
                plans: _vm.plans,
                "selected-plan-id": _vm.form.membership_plan,
                "membership-type": this.form.payment_type,
                "customer-credit": _vm.credit,
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ml-2" }, [
      _vm._v("\n                                I have read and agree to the "),
      _c(
        "a",
        {
          staticClass: "text-primary-600 hover:underline",
          attrs: { href: "/terms-and-conditions", target: "_blank" },
        },
        [_vm._v("terms and conditions")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }